const initialState = {
  jobs: [],
  filters: [],
}

export default initialState;